import React from 'react';
import PropTypes from 'prop-types';

import Layout from '../layout';
import GenericPage from './index';


function GenericPageTemplate(props) {
  /* eslint-disable react/destructuring-assignment */
  return (
    <Layout
      location={props.location}
      pageContext={props.pageContext}
    >
      <GenericPage {...props} />
    </Layout>
  );
  /* eslint-enable react/destructuring-assignment */
}

GenericPageTemplate.propTypes = {
  pageContext: PropTypes.shape({
    seoFields: PropTypes.object,
    titoloPagina: PropTypes.string,
  }).isRequired,
  location: PropTypes.object,
};

export default GenericPageTemplate;
